import React from 'react';
import styled from 'styled-components';


const Message = ({ own, children }) => {


    return (

        <Container own={own}>
            <FormattedMessage own={own}>
                { children }
            </FormattedMessage>
        </Container>

    )

}

export default Message;


const Container = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:${props => props.own ? 'flex-end' : 'flex-start'};
    align-content:center;
    width:100%;
    padding:5px 10px;
`


const FormattedMessage = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-content:center;
    position:relative;
    max-width:90%;
    height:100%;
    background: ${props => props.own ? 'rgb(211, 227, 248)' : 'transparent' };
    border-radius:25px;
    padding:10px 15px;
    color: #000000;
    font-size:14px;
  
`

const SenderContainer = styled.div`
    display:flex;
`
